import { useEffect } from "react";
import { setRequestFlowLanguage } from "@/lib/api/_client";

/**
 * QL-17 — while the calling component is mounted, every API request carries
 * the flow language, so API errors come back in it. The advisor flow wizard
 * calls this once at its top. Don't call it from `FlowLanguageScope`: those
 * scopes nest, and an inner one unmounting would clear the language while
 * the wizard is still open.
 */
export function useRequestFlowLanguage(language: string): void {
  // Set during render too: children's effects (their first queries) run
  // before this component's effect, and would otherwise go out without it.
  setRequestFlowLanguage(language);
  useEffect(() => {
    setRequestFlowLanguage(language);
    return () => setRequestFlowLanguage(null);
  }, [language]);
}
